import { render } from "./requestor_dashboard.html?vue&type=template&id=bd86b004&external"
import script from "./requestor_dashboard.js?vue&type=script&lang=js&external"
export * from "./requestor_dashboard.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__